'use strict';

exports.__esModule = true;
exports['default'] = {
  ROW: 'cb-row',
  COL: 'cb-col',
  GRID: 'cb-grid'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-cellblock/lib/util/constants.js
// module id = 172
// module chunks = 0